export default {
  formatDateToThaiString(date) {
    if (!date) {
      return "";
    }

    const dateStr = date.toString().padEnd(8, "0");
    let [year, month, day] = [
      dateStr.substring(0, 4),
      dateStr.substring(4, 6),
      dateStr.substring(6),
    ];

    day = day.charAt(0) === "0" ? day.substring(1) : day;

    const thaiMonths = {
      "01": "มกราคม",
      "02": "กุมภาพันธ์",
      "03": "มีนาคม",
      "04": "เมษายน",
      "05": "พฤษภาคม",
      "06": "มิถุนายน",
      "07": "กรกฎาคม",
      "08": "สิงหาคม",
      "09": "กันยายน",
      10: "ตุลาคม",
      11: "พฤศจิกายน",
      12: "ธันวาคม",
    };
    month = thaiMonths[month] || "";

    return `${day} เดือน ${month} พ.ศ. ${year}`;
  },
  formattime(time) {
    return time.substring(0, 2) + "." + time.substring(2, 4);
  },
  formatNote(Note) {
    let SetNote = Note;
    let splitNote = "";
    splitNote = SetNote.split("\r\n");
    return splitNote;
  },
  formatNumberToThai(number) {
    let chars = {
      0: "๐",
      1: "๑",
      2: "๒",
      3: "๓",
      4: "๔",
      5: "๕",
      6: "๖",
      7: "๗",
      8: "๘",
      9: "๙",
    };
    return number.replace(/[1234567890]/g, (m) => chars[m]);
  },
  mergeNote(Note) {
    let Noteall = "";
    Noteall +=
      Note.notes1 +
      Note.notes2 +
      Note.notes3 +
      Note.notes4 +
      Note.notes5 +
      Note.notes6 +
      Note.notes7 +
      Note.notes8;
    return Noteall;
  },
  formatPrice(value) {
    let intPartFormat = value;
    if (value === "" || value.length < 3) {
      return intPartFormat;
    } else {
      let intPart = parseInt(value).toFixed(0);
      intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    }
    return intPartFormat;
  },
  formatPid(pid) {
    return (
      pid.toString().substring(0, 1) +
      "-" +
      pid.toString().substring(1, 5) +
      "-" +
      pid.toString().substring(5, 10) +
      "-" +
      pid.toString().substring(10, 12) +
      "-" +
      pid.toString().substring(12, 13)
    );
  },
};
